document.addEventListener("DOMContentLoaded", () => {  
  const templates = {
    Birthday: [
      "Happy birthday, beautiful! Hope your day's full of laughter, lazy moments, and way too much cake.",
      "Happy birthday! You deserve a day that's as gorgeous & golden as you are. Hope this year brings you everything you've been dreaming of (& a little extra sparkle too).",
      "Another year older, wiser, and even more stunning, how do you do it? Happy birthday my love! Keep shining.",
      "Cheers to you! Your laugh, your energy, your heart. Never stop being this amazing. Happy birthday!"
    ],
    Anniversary: [
      "You and me, we've made it this far with laughter, chaos, and so much love. Wouldn't change a thing.",
      "Here's to us, the weird jokes, the late nights, and all the moments that made it worth it. Happy anniversary my love!",
      "Another year of being us, messy, real, and somehow perfect together. And I would not have it any other way!",
      "If I could do it all again, I'd still choose you, just faster this time. Happy anniversary sunshine. Stay with me forever!"
    ],
    "Thank You": [
      "You make everything brighter, just by being around. Thank you for being you. Stay the same always!",
      "For all the things you do without ever being asked, you're honestly one of a kind, and I have never thanked you enough for being you!",
      "You've been my calm, my chaos, and my biggest cheerleader. I can't thank you enough.",
      "You make people feel seen and loved, and that's rare. Here's a little something to say thank you for all the big and small things you do."
    ],
    "Celebrating Her": [
      "For the woman who just does it all, and somehow still makes it look so easy. You make my world fall into place.",
      "You're strong, funny, kind and my sunshine. Basically the full package and you're mine.",
      "You don't need a reason to be celebrated, but I'll give you one anyway.",
      "You're a living proof that women can do absolutely everything and look pretty damn good doing it. Just a little reminder that you're loved, appreciated, and totally unstoppable."
    ],
    "Thinking of You": [
      "Just thought you deserved a little something special that would make you smile.",
      "You popped into my head, and I figured, why not make your day a little brighter?",
      "You're the kind of person who deserves surprises for no reason at all. Life's simply so much better with you in it.",
      "This is just a tiny way to tell you, you're amazing, and I hope you never forget it."
    ]
  };

  const occasionBoxes = document.querySelectorAll(".gift-occasion-wrapper:not(.gift-fonts):not(.gift-color-picker) .gift-label-box");
  const messageTemplateContainer = document.querySelector(".gift-mess-template");
  const textarea = document.querySelector(".gift-message-textholder textarea");
  const giftTypeBoxes = document.querySelectorAll(".gift-box-wrapper .gift-type-box");
  const fontBoxes = document.querySelectorAll(".gift-fonts .gift-label-box");  
  const colorBoxes = document.querySelectorAll(".gift-color-picker .gift-color-option");
  const saveBtn = document.querySelector(".preview_gifting_form");
  const senderInput = document.querySelectorAll(".gift-contact-wrapper input")[0];
  const receiverInput = document.querySelectorAll(".gift-contact-wrapper input")[1];
  const loader = document.querySelector(".gift-loader");
  const previewBox = document.querySelector(".gift-card-preview");
  const giftProductWrapper = document.querySelector(".gift-product-wrapper");  
  const checkoutGiftBox = document.querySelector(".checkout-gift-box");  

  let selectedGiftBox = "standard";
  let selectedOccasion = "Birthday";
  let selectedTemplate = "";
  let selectedFont = "inherit";
  let selectedColor = "inherit";

  function setSelected(list, selectedBox, selectedName, value) {
    list.forEach(item => item.classList.remove("selected"));
    selectedBox.classList.add("selected");
    selectedBox.setAttribute(selectedName, value);
  }

  const attachMessageClickHandlers = () => {
    if(messageTemplateContainer){
      const messageSpans = messageTemplateContainer.querySelectorAll(".gift-label-box");
      messageSpans.forEach(span => {
        span.addEventListener("click", () => {
          setSelected(messageSpans, span);
          textarea.value = span.textContent.trim();
          selectedTemplate = span.textContent.trim();
        });
      });
    }
  };

  if(occasionBoxes){
    occasionBoxes.forEach(box => {
      box.addEventListener("click", () => {
        selectedOccasion = box.textContent.trim();
        setSelected(occasionBoxes, box);
        
        messageTemplateContainer.innerHTML = "";
        templates[selectedOccasion].forEach(msg => {
          const span = document.createElement("span");
          span.className = "gift-label-box";
          span.textContent = msg;
          messageTemplateContainer.appendChild(span);
        });
  
        attachMessageClickHandlers();
      });
    });
  }

  const defaultOccasionBox = Array.from(occasionBoxes).find(el => el.textContent.trim() === "Birthday");
  if (defaultOccasionBox) defaultOccasionBox.classList.add("selected");
  attachMessageClickHandlers();
  
  if(fontBoxes){
    fontBoxes.forEach(box => {
      box.addEventListener("click", () => {
          selectedFont = box.dataset.font;
          setSelected(fontBoxes, box, "data-selected", selectedFont);
      });
    });
  }

  if(giftTypeBoxes){
    giftTypeBoxes.forEach(box => {
      box.addEventListener("click", () => {
          selectedGiftBox = box.dataset.box;
          setSelected(giftTypeBoxes, box, "data-selected", selectedGiftBox);
          if(selectedGiftBox == "standard"){
            document.querySelectorAll(".hideWhenStd").forEach((field) => field.style.display = "none");            
            previewBox.style.display = "none";
            selectedTemplate = "";
            textarea.value = "";
            selectedFont = "inherit";
            selectedColor = "inherit";
            giftProductWrapper.style.display = "none";
          } else{
            document.querySelectorAll(".hideWhenStd").forEach((field) => field.style.display = "block");
            previewBox.style.display = "none";
            giftProductWrapper.style.display = "none";
          }
      });
    });
  }
  
  if(colorBoxes){    
    colorBoxes.forEach(box => {
      box.addEventListener("click", () => {
          selectedColor = box.dataset.color;
          setSelected(colorBoxes, box, "data-selected", selectedColor);
      });
    });
  }

  if(saveBtn){
    saveBtn.addEventListener("click", () => {
      const data = {
        occasion: selectedOccasion,
        message: textarea.value.trim(),
        font: selectedFont,
        color: selectedColor,
        sender: senderInput.value.trim(),
        receiver: receiverInput.value.trim()
      };    
      console.log("Gift Form Data:", data);
      if(selectedGiftBox === "custom" && (data.font === "standard" || data.color === "standard")){
        alert("Please fill all fields and make your selections before previewing!");
        return;
      }
      if (!data.occasion || !data.message || !data.font || !data.color || !data.sender || !data.receiver) {
          alert("Please fill all fields and make your selections before previewing!");
          return;
      }    
      loader.style.display = "flex";
      previewBox.style.display = "none";
      console.log("We selected: ", selectedGiftBox);
      setTimeout(() => {        
          loader.style.display = "none";
          let receiverSpan = previewBox.querySelector(".preview-receiver");
          receiverSpan.textContent = data.receiver;
          receiverSpan.style.fontFamily = data.font;        
          receiverSpan.style.color = data.color;        
          previewBox.querySelector(".mess-content").textContent = data.message;
          previewBox.querySelector(".preview-sender").textContent = data.sender;
          previewBox.style.display = "block";
          if(selectedGiftBox === "standard"){
            giftProductWrapper.querySelectorAll('.stdField').forEach((item) => item.style.display = "block");
            giftProductWrapper.querySelectorAll('.customField').forEach((item) => item.style.display = "none");
          } else{
            giftProductWrapper.querySelectorAll('.stdField').forEach((item) => item.style.display = "none");
            giftProductWrapper.querySelectorAll('.customField').forEach((item) => item.style.display = "block");
          }
          giftProductWrapper.style.display = "block"; 
      }, 1000);
    });
  }

  if(checkoutGiftBox){
    checkoutGiftBox.addEventListener("click", () => {
      loader.style.display = "flex";
      const data = {
        occasion: selectedOccasion,
        message: textarea.value.trim(),
        font: selectedFont,
        color: selectedColor,
        sender: senderInput.value.trim(),
        receiver: receiverInput.value.trim()
      };    
      const noteContent = `
        Occasion: ${data.occasion}
        Message: ${data.message}
        Font: ${data.font}
        Color: ${data.color}
        Sender: ${data.sender}
        Receiver: ${data.receiver}
      `.trim();
      
      if (!data.occasion || !data.message || !data.font || !data.color || !data.sender || !data.receiver) {
        alert("Please fill all fields and make your selections before checkout!");
        return;
      }
      
      const items = selectedGiftBox === "standard" ? [{ id: 49555432046869, quantity: 1 }] : [{ id: 49406003216661, quantity: 1 }];
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
        .then(res => {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then(() => {
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({     
              attributes: {
                Occasion: null,
                Message: null,
                Font: null,
                Color: null,
                Sender: null,
                Receiver: null
              },       
              note: noteContent
            })
          });
        })
        .then(res => {
          if (!res.ok) throw new Error("Failed to update cart attributes");
          return res.json();
        })
        .then(() => {
          // window.location.reload();
          handleFloCheckoutBtn();        
        })
        .catch(err => {
          console.error(err);
          alert("Something went wrong, Reload & Try Again.");        
        })
        .finally(()=>{
          loader.style.display = "none";
        });
    });
  }
});